<template>
  <div class='scheduler-body'>
    <div>
      <label>Group By:</label>
      <select v-model='schedulerOptions.columnFilter'>
        <option v-for='f in schedulerOptions.columnGroupFunctions' :value='f'>{{f.name}}</option>
      </select>
      <h3>Rooms</h3>
      <div>
        <expandButton 
          v-for='room in rooms'
          :key='room.id'
          :expanded='expandedRoom === room'
          class='room-edit-field'>
          <template slot='header'>
            <div>{{room.name}}</div>
            <div @click='toggleRoomExpanded(room)'><i class='far fa-edit'/></div>
          </template>
          <template slot='body'>
            <label>Name:</label>
            <input v-model='roomEditFields.name' class='dark'></input>
            <label>ID:</label>
            <div>{{room.id}}</div>
            <button 
              @click='editRoom(room)'
            >Save</button>
          </template>
        </expandButton>
        <expandButton 
          :expanded='addRoomExpanded'
          class='room-edit-field'>
          <template slot='header'>
            <a @click='addRoomExpanded = !addRoomExpanded'>Add a New Room</a>
          </template>
          <template slot='body'>
            <label>Name:</label>
            <input v-model='newRoom.name' class='dark'></input>
            <button 
              @click='createNewRoom(newRoom)'
            >Save</button>
          </template>
        </expandButton>
      </div>
      <h3>Tracks</h3>
    </div>
    <div>
      <periodEditor
        @periodAdded='periodAdded'
        @periodUpdated='periodUpdated'
        @periodRemoved='periodRemoved'
        :rooms='rooms'
        :editingPeriod.sync='editingPeriod'
      />
      <scheduler
        :columnGroups='schedulerOptions.columnGroupFunctions'
        :columnFilter='schedulerOptions.columnFilter'
        :defaultOptions='schedulerOptions.defaultOptions'
        :start='schedulerOptions.start'
        :existingPeriods='periods'
        :editingPeriod.sync='editingPeriod'
        >
      </scheduler>
    </div>
  </div>
</template>

<script>
import scheduler from "@/components/event/scheduler.vue";
import periodEditor from "@/components/event/periodEditor.vue";
import expandButton from "@/components/expandButton.vue";
import { columnGroupFunctions } from "@/components/event/scheduler.vue";
import { DateTime, Interval } from "luxon";
export default {
  props: ["id"],
  data() {
    return {
      event: null,
      schedulerOptions: {
        columnGroupFunctions,
        defaultOptions: {
          location: [],
          start: []
        },
        columnFilter: columnGroupFunctions.start,
        start: DateTime.local().startOf("day")
      },
      editingPeriod: null,
      expandedRoom: null,
      addRoomExpanded: false,
      roomEditFields: {
        name: ""
      },
      newRoom: {
        name: ""
      }
    };
  },
  methods: {
    toggleRoomExpanded(room) {
      if (this.expandedRoom === room) {
        this.expandedRoom = null;
      } else {
        this.expandedRoom = room;
        this.roomEditFields.name = room.name;
      }
    },
    getEvent: function() {
      return this.$store
        .dispatch("events/get", { id: this.id })
        .then(() => this.$store.getters["events/event"](this.id));
    },
    periodAdded(period) {
      this.$store
        .dispatch("events/addSession", {
          eventId: this.id,
          session: period
        })
        .then(() => {
          this.editingPeriod = null;
        });
    },
    periodRemoved(period) {
      this.$store
        .dispatch("events/deleteSession", {
          eventId: this.id,
          sessionId: period.id
        })
        .then(() => {
          this.editingPeriod = null;
        });
    },
    periodUpdated(update) {
      this.$store
        .dispatch("events/updateSession", {
          sessionId: this.editingPeriod.id,
          update: update
        })
        .then(() => {
          this.editingPeriod = null;
        });
    },
    createNewRoom(room) {
      this.$store.dispatch("events/addRoom", { eventId: this.event.id, room });
    },
    editRoom(room) {
      this.$store.dispatch("events/editRoom", {
        roomId: room.id,
        update: this.roomEditFields
      });
    },
    periodEditing(period) {
      this.editingPeriod = period;
    },
    closeEdit() {
      this.editingPeriod = null;
    }
  },
  computed: {
    rooms() {
      var result = [];
      if (this.event) {
        for (var id in this.event.rooms) {
          result.push(this.event.rooms[id]);
        }
      }
      return result;
    },
    periods: function() {
      const r = [];
      if (!this.event) return r;
      for (var i in this.event.sessions) {
        r.push(this.event.sessions[i]);
      }
      return r;
    }
  },
  beforeMount: function() {
    this.getEvent().then(event => {
      this.event = event;
      const start = event.start.startOf("day");
      const end = event.end.startOf("day");

      this.schedulerOptions.start = start;
      this.schedulerOptions.periods = this.periods;
      this.schedulerOptions.defaultOptions.location.push("unset");

      var n = start;
      while (n <= end) {
        this.schedulerOptions.defaultOptions.start.push(n);
        n = n.plus({ days: 1 });
      }
    });
  },
  components: {
    scheduler,
    expandButton,
    periodEditor
  }
};
</script>

<style scoped lang='scss'>
.scheduler-body {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  > div:first-child {
    width: 250px;
    border: 1px solid grey;
  }
  > div:last-child {
    flex-grow: 1;
    position: relative;
  }
}
.room-edit-field {
  margin: 8px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/schedule.vue